import React, { useEffect } from 'react';
import { CheckboxInput, Typography } from '@guildeducationinc/recess';
import { useHits, useRefinementList } from 'react-instantsearch-hooks-web';
import { trackClickedFilters, trackEvent } from '@src/services/analytics';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import {
	genericRolesRefinementListAttributeMapping,
	refinementListAttributeMapping,
	specificRolesRefinementListAttributeMapping,
} from 'src/components/RefinementListChildFilter/refinementListChildFilterHelpers';
import { useDecision } from '@optimizely/react-sdk';
import { getRolesToDisplay, ROLE_MAPPING, RoleVariaions } from '@src/constants/featureFlags';
import { useSearchContext } from '../Providers/SearchProvider';

interface Props {
	filterCategory?: string;
	parent: string;
	setSelectedChildrenFilterCount: (count: number) => void;
}

export const RefinementListChildFilter: React.FC<Props> = props => {
	const [rolesDecision] = useDecision(ROLE_MAPPING);
	const rolesAttributeMapping =
		getRolesToDisplay(rolesDecision) === RoleVariaions.GENERIC
			? genericRolesRefinementListAttributeMapping
			: specificRolesRefinementListAttributeMapping;
	const attributes = rolesDecision.enabled ? rolesAttributeMapping : refinementListAttributeMapping;
	const { items, refine } = useRefinementList({
		attribute: attributes[props.parent],
		limit: 100,
		sortBy: ['name'],
	});
	const { results } = useHits();
	const { userFromIdToken: user } = useMemberExperienceAuth();
	const { index } = useSearchContext();
	useEffect(() => {
		const selectedFacetsCount = items.filter(facet => facet.isRefined).length;
		props.setSelectedChildrenFilterCount(selectedFacetsCount);
	}, [items, props]);

	const filteredChildren = items.filter(item => item.value.includes(`${props.parent} >`));

	return (
		<>
			{filteredChildren.map(facet => {
				return (
					<div className='margin--left_16' key={facet.value}>
						<CheckboxInput
							checked={facet.isRefined}
							data-testid={`${facet.value}-checkbox`}
							label={
								<Typography
									className='cursor--pointer'
									variant='body1'
									weight='normal'
								>{`${facet.label.split('>')[1]} (${facet.count})`}</Typography>
							}
							name={facet.value}
							onChange={() => {
								refine(facet.value);
								const eventName = facet.isRefined ? 'FilterRemoved' : 'FilterAdded';
								trackEvent(eventName, {
									filterCategory: props.filterCategory,
									filterValue: [facet.value],
								});
								trackClickedFilters({
									filters: [`${attributes[props.parent]}:${facet.value}`],
									index,
									queryId: results.queryID,
									userUuid: user.id,
								});
							}}
						/>
					</div>
				);
			})}
		</>
	);
};
